import React from 'react';

import { useFetch, useDelete } from 'hooks';
import CrmIntegrationService from 'api/CrmIntegration';
import { connect } from 'react-redux';
import SettingsActions from 'store/reducers/Settings';
import IntegrationView from 'views/Administration/Integration';
import { useHistory } from 'react-router-dom';

const Integration = ( { toggleErrorAlert,toggleLoading,history } ) => {
  // const history=useHistory()
  const [data, dataLoading] = useFetch( {
    initialState: [],
    promise: () => CrmIntegrationService.getIntegrations( { limit: -1, 'filters[active]': '1' } ),
    format: ( dataToFormat ) => dataToFormat.data,
    toggleErrorAlert,
    deps: [],
  } );

  const deleteEntity = useDelete({
    promise: CrmIntegrationService.deleteData,
    callback: () => window.location.reload(),
    toggleLoading,
    toggleErrorAlert,
  });

  return (
    <IntegrationView
      data={data}
      isLoading={dataLoading}
      onDelete={deleteEntity}
    />
  );
};

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  toggleLoading: SettingsActions.toggleLoading
} );

export default connect( null, mapDispatchToProps )( Integration );
